// ISO 6346 container-number check, without the extra equipment-category rule
// (the 4th character may be any letter). Letter values skip multiples of 11.

export const ISO6346_CONTAINER_NUMBER_CALLBACK = "iso6346_container_number";

export const ISO6346_CONTAINER_NUMBER_HINT = "Container number must be 4 letters, 6 digits and a valid check digit";

// A is 10. Each later letter is one higher, and multiples of 11 are skipped,
// so B is 12 rather than 11. Equivalent to charCode - 55 plus the skips so far.
function characterValue(character: string): number {
    if (character >= "0" && character <= "9") {
        return Number(character);
    }
    const code = character.charCodeAt(0) - 55;
    return code + Math.floor((code - 1) / 10);
}

function checkDigit(body: string): number {
    let sum = 0;
    for (let index = 0; index < body.length; index += 1) {
        sum += characterValue(body[index]) * (2 ** index);
    }
    const remainder = sum % 11;
    return remainder === 10 ? 0 : remainder;
}

export function isIso6346ContainerNumber(value: unknown): boolean {
    if (typeof value !== "string") {
        return false;
    }
    const normalized = value.trim().toUpperCase();
    if (!/^[A-Z]{4}\d{7}$/.test(normalized)) {
        return false;
    }
    return normalized[10] === String(checkDigit(normalized.slice(0, 10)));
}

export function iso6346ContainerNumberOnChange({ setValue, field, value }: {
    setValue: (field: string, value: unknown) => void;
    field: string;
    value: unknown;
}): void {
    setValue(field, typeof value === "string" ? value.toUpperCase() : value);
}

// Empty stays valid so a mandatory check can own it. A value still equal to the
// stored baseline stays valid, so a temporary voyage label is left alone until
// the field is actually changed.
export function onChangeCallbackRejects(
    callbackName: unknown,
    value: unknown,
    baseline?: { value: unknown },
): boolean {
    if (callbackName !== ISO6346_CONTAINER_NUMBER_CALLBACK) {
        return false;
    }
    if (baseline && baseline.value === value) {
        return false;
    }
    if (value === undefined || value === null || value === "") {
        return false;
    }
    return !isIso6346ContainerNumber(value);
}
